import i18next from "i18next";

export class ResponseError extends Error {
  public response: Response;

  constructor(response: Response) {
    super(response.statusText);
    this.response = response;
  }
}

function parseJSON(response: Response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

async function checkStatus(response: Response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new ResponseError(response);
  const res = await response.text();
  error.message = res;
  error.response = response;
  throw error;
}

const defaultOptions = (): RequestInit => {
  const sessionToken = localStorage.getItem("sessionToken");
  const language =
    localStorage.getItem("i18nextLng") || i18next.language || "en";
  return {
    headers: {
      "Content-Type": "application/json",
      "x-custom-lang": language,
      "x-timestamp": String(Date.now() * 1000),
      ...(sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {}),
    },
  };
};

/**
 * Shared fetch helper — same pattern Silagi had originally.
 * Sagas wrap calls in try/catch.
 */
export async function request(url: string, options?: RequestInit) {
  const defaults = defaultOptions();
  const payload: RequestInit = {
    ...defaults,
    ...options,
    headers: {
      ...(defaults.headers as Record<string, string>),
      ...(options?.headers as Record<string, string>),
    },
  };
  const fetchResponse = await fetch(url, payload);
  const response = await checkStatus(fetchResponse);
  return parseJSON(response);
}